export default __webpack_public_path__ + "static/media/more.539440a1.svg";